import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import { Row, Col, Card, Container } from "react-bootstrap";
import { FaFax, FaPhoneAlt, FaMobile, FaEnvelope } from "react-icons/fa";
import { Link, NavLink } from "react-router-dom";
import FormModal from "../home/FormModal.jsx";
import SocialMediaIcons from "./SocialMediaIcons.jsx";
import NewsLetterSubscriptionForm from "../emails/NewsLetterSubscriptionForm.jsx";

const getCurrentYear = () => {
  let date = new Date();
  let year = date.getFullYear();
  return year;
};

function Footer({ footerImage }) {
  useEffect(() => {
    Aos.init({ duration: 2000, delay: 2 });
  }, []);

  return (
    <footer className="footer--footer">
      <Card className="border-0">
        <div className="overlay--footer" style={{
          background: `linear-gradient(
            rgba(0, 92, 169, 0.5),
            rgba(217, 0, 27, 0.5)
          ), url("${footerImage}")`
        }}>
          <h1
            className="font-x-large"
            data-aos="fade-down"
            id="font-white"
            style={{ marginTop: "5rem" }}
          >
            WANT TO KNOW MORE?
          </h1>
          <div>
            <FormModal />
          </div>
        </div>

        <Card.Body className="text-dark text-center p-0">
          <Row className="bg-white text-dark">
            <div className="mapouter">
              <div className="gmap_canvas">
                <iframe
                  title="Paulines Africa Location"
                  className="gmap_iframe"
                  width="100%"

                  src="https://maps.google.com/maps?height=400&amp;hl=en&amp;q=Paulines Africa westlands&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                ></iframe>

              </div>
            </div>
          </Row>
          <div className="bg-main">
            <Container>

              <Row className="text-light text-center pt-5 justify-content-center">
                <Col xs={12} md={3} className="text-light">
                  <ul className="list-unstyled text-start">
                    <li>
                      <h1 className="text-light underline ">Contact us</h1>
                    </li>
                    <li>
                      <address className="text-left">
                        Daughters of St Paul
                        <br />
                        P.O. Box 49026 00100
                        <br />
                        Nairobi GPO(Kenya)
                        <br />
                        <FaPhoneAlt /> Tel:{" "}
                        <a href="tel:(020)4447202/03">(020) 4447202/03</a>.<br />
                        <FaFax /> Fax: <a href="fax:4442097">4442097</a>.<br />
                        <FaMobile /> Mob:{" "}
                        <a href="tel:+254727736621">+254 727 736 621</a>.<br />
                        <FaEnvelope /> Email:{" "}
                        <a href="mailto:publications@paulinesafrica.org">
                          publications@paulinesafrica.org
                        </a>
                        .<br />
                      </address>
                    </li>
                  </ul>
                </Col>

                <Col xs={12} md={3} className="text-light">
                  <h1 className="color-primary text-start">Connect with us</h1>
                  <SocialMediaIcons />
                </Col>

                <Col xs={12} md={3} className="text-light">
                  <ul className="list-unstyled text-start text-capitalize">
                    <li>
                      <h1 className="text-light underline ">Daughters of St Paul</h1>
                    </li>
                    <li>
                      <Link to="/founders">Founders</Link>
                    </li>
                    <li>
                      <Link to="/history">Our history</Link>
                    </li>
                    <li>
                      <Link to="/spirituality">Our spirituality</Link>
                    </li>
                    <li>
                      <Link to="/mission">Our mission</Link>
                    </li>
                    <li>
                      <Link to="/cooperators">Pauline cooperators and Events</Link>
                    </li>
                    <li>
                      <NavLink to='https://www.paoline.org'>News </NavLink>
                    </li>
                  </ul>
                </Col>

                <Col xs={12} md={3} className="text-light p-0 m-0 text-center">
                  <h1 className="text-center">Newsletter</h1>
                  <NewsLetterSubscriptionForm />
                </Col>

                <Col xs={12} className="text-light">
                  <p className="text-capitalize">
                    Paulines publications Africa &copy; {getCurrentYear()}
                  </p>
                </Col>
              </Row>

            </Container>
          </div>
        </Card.Body>
      </Card>
    </footer >
  );
}

export default Footer;
